import { action, computed, observable, toJS } from 'mobx';

type FeatureFlags = Record<string, string>;

export default class FeatureFlagsStore {
  @observable _flags: FeatureFlags = {};
  @observable loading = true;

  @action
  setFlags(newFlags: FeatureFlags): void {
    if (Object.keys(newFlags).length) {
      this.loading = false;
    }
    this._flags = newFlags;
  }
  @computed
  get flags(): FeatureFlags {
    return toJS(this._flags);
  }
}
